import { createSafeContext } from '@/package';

import type { WebSocketContextValue } from './type';

const WebSocketContext = createSafeContext<WebSocketContextValue>(
  {} as WebSocketContextValue,
  'WebSocketContext',
);

export default WebSocketContext;
